class Validate {
	static isEmail(email) {
		let pattern = /(^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)+$)/gi;
		return pattern.test(email);
	}

	static isPassword(passwd) {
		//let pattern =/((?=.*\d)(?=.*[a-zA-Z]).{6,20})/g;  // <-- pattern from the internet
		// better pattern for password  (?<!(\S|\s))(?=.*\d)(?=.*[a-zA-Z])(?=.*[$!%&*]).{6,20}(?!(\S|\s))
		// <-- this pattern looks for anything before and after the max 20 and fails to match if there is more than 20
	
		// let pattern = /(?<!(\S|\s))(?=.*\d)(?=.*[a-zA-Z])(?=.*[$!%&*]).{6,20}(?!(\S|\s))/g; // <- safari browser can't do negative lookahead
		// let pattern = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[$!%@&#*%^?])[\S]{6,20}$/g;
		let pattern = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*(){}\-_=+\[\];:\'\"\\,<.>|/?])[\S]{6,20}$/g;
		return pattern.test(passwd);
	}

	constructor(form, actionButton, checkChanges) {
		this._button = actionButton;
		this._validationFields = [];
		this._changeFields = [];
		this._warnings = [];
		this._email = false;
		this._username = false;
		this._failCount = 0;
		this._changeCount = 0;
		this._checkChanges = checkChanges || false;

		onEv(actionButton, 'mousedown touchstart', this.disarm.bind(this));
		for(let elem of form.elements) {
			if (elem.hasAttribute('data-prev')) {
				this._changeFields.push(elem);
			}
			if (elem.hasAttribute('data-validate')){
				this._validationFields.push(elem);
				this._warnings.push(null);

				onEv(elem, 'blur', () => {
					elem.warn = true;
				});

				if (elem.type == 'checkbox' || elem.type == 'select-one') {
					onEv(elem, 'change', this.validate.bind(this));
				} else {
					onEv(elem, 'keyup blur paste', this.validate.bind(this));
					for (let check of elem.getAttribute('data-validate').split(' ')) {
						switch (check) {
							case 'email' : this._email = elem; break;
							case 'username' : this._username = elem; break;
						}
					}
				}
			}
		}
		this.validate();
	}

	armField(elem) {
		// added a delay to arming the field as focus started firing before the key up on previous field
		setTimeout(() => {
			elem.warn = true;
		}, 800);
	}
	
	armAll() {
		for (let elem of this._validationFields) elem.warn = true;
		this.validate();
	}

	disarm() {
		this._validationFields.forEach((f) => f.warn = false);
	}

	reset() {
		this.disarm();
		this.validate();
	}

	validate() {
		this._failCount = 0;
		this._changeCount = 0;
		for (let field of this._validationFields) this.checks(field);
		for (let field of this._changeFields) this.changed(field);
		this._button.disabled = 0 < this._failCount || (this._checkChanges && this._changeCount == 0);
	}

	changed(f) {
		if (f.type == 'checkbox') {
			if (!!f.getAttribute('data-prev') != !!f.checked) this._changeCount++;
		}
		else {
			if (f.getAttribute('data-prev') != f.value) this._changeCount++;
		}
	}

	checks(field) {
		for (let check of field.getAttribute('data-validate').split(' ')) {
			if (this.doCheck(field, check) == false) return;
		}
		this.clearWarning(field);
	}

	doCheck(field, check) {
		switch (check) {
			case 'required': return this.required(field);
			case 'name': return this.name(field);
			case 'reqWithoutUsername': return this.reqWithoutUsername(field);
			case 'email': return this.emailFormat(field);
			case 'emailUsed': return this.emailNotUsed(field);
			case 'reqWithoutEmail': return this.reqWithoutEmail(field);
			case 'username': return this.usernameFormat(field);
			case 'usernameUsed': return this.usernameNotUsed(field);
			case 'password': return this.password(field);
		}
	}

	required(field) {
		if (field.value.length) return true;

		this.showWarning(field, field.getAttribute('aria-label') + _(' is required'));
		return false;
	}

	name(field) {
		let na = field.value.trim().split(' ');
		
		if (Array.isArray(na) && na.length > 1) return true;
		this.showWarning(field, 'Please enter first and last name');
		return false;
	}

	emailFormat(field) {
		if (field.value.length == 0 || Validate.isEmail(field.value)) return true;
		
		this.showWarning(field, 'Email address is invalid');
		return false;
	}

	reqWithoutUsername(field) {
		if (field.value.length || this.hasUsername) return true;

		this.showWarning(field, 'Email address is require if no username');
		return false;
	}
	
	emailNotUsed(field) {
		if (field.value.length == 0) return true;
		if (field.hasAttribute('data-prev') && field.getAttribute('data-prev') == field.value) return true;
	
		ajg('validation.php', ['field=email', 'value=' + encodeURI(field.value)], null, (reply) => {
			if (reply.error) {
				this.showWarning(field, reply.error);
			}
			else {
				this.clearWarning(field);
			}
			this._button.disabled = this._failCount;
		}, this);	
		return true;
	}
	
	usernameFormat(field) {
		if (field.value.length == 0 || field.value.length > 5) return true;

		this.showWarning(field, _("A username must be a least 6 characters long"));
		return false;
	}

	reqWithoutEmail(field) {
		if (field.value.length || this.hasEmail) return true;

		this.showWarning(field, 'Username is required if no email address');
		return false;
	}

	usernameNotUsed(field) {
		if (field.value.length == 0) return true;
		if (field.hasAttribute('data-prev') && field.getAttribute('data-prev') == field.value) return true;

		ajg('validation.php', ['field=username', 'value=' + encodeURI(field.value)], null, (reply) => {
			if (reply.error) {
				this.showWarning(field, reply.error);
			}
			else {
				this.clearWarning(field);
			}
			this._button.disabled = this._failCount;
		}, this);
		return true;
	}

	password(field) {
		if (field.value.length == 0) return true;
		if (Validate.isPassword(field.value)) return true;

		this.showWarning(field, _("6 to 20 characters with letter, numbers and symbols"))
		return false;
	}

	get hasUsername() {
		return this._username && this._username.value.length;
	}

	get hasEmail() {
		return this._email && this._email.value.length;
	}

	showWarning(elem, message) {
		this._failCount++;

		if (!elem.warn) return;

		let i = this._validationFields.indexOf(elem);
		if (this._warnings[i] == null) {
			this._warnings[i] = div('form-warning', message);
			elem.parentNode.insertBefore(this._warnings[i], elem);
		}
		else {
			this._warnings[i].innerText = message;
		}

		state(elem, 'warn');
	}

	clearWarning(elem) {
		let i = this._validationFields.indexOf(elem);
		if (this._warnings[i] != null) {
			this._warnings[i].remove();
			this._warnings[i] = null;
		}
	}
}